import React, { useState } from 'react';
import { Button, message, Upload, Spin, Row, Col } from 'antd';
import { UploadOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { uploadImageToCloudinary } from '../../services/CloudinaryService';

const ImageUploadForm = ({ onImageUpload }) => {
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    try {
      setLoading(true);

      // Upload the image to Cloudinary
      const imageUrl = await uploadImageToCloudinary();
      message.success('Image uploaded successfully');

      // Notify the parent component with the image URL
      onImageUpload(imageUrl);
      console.log(imageUrl);
    } catch (error) {
      message.error('Image upload failed');
    } finally {
      setLoading(false);
    }
  };

  return (

    
    <div style={{ textAlign: 'center', marginTop: '20px' }}>

<Row justify="center">
        <Col>
          <Button
            type="primary"
            shape="round"
            icon={loading ? <Spin /> : <CloudUploadOutlined />}
            size="large"
            style={{
              background: '#40a9ff',
              borderColor: '#40a9ff',
              color: '#fff',
              padding: '0 30px',
            }}
            onClick={handleUpload}
          >
            {loading ? 'Uploading...' : 'Upload article cover image'}
          </Button>
        </Col>
      </Row>
     
    </div>
  );
};

export default ImageUploadForm;
